import React from 'react';
import './CaseStudyContent.css';
import TextoConImagenes from './TextoConImagenes';

function CaseStudyContent({ caseStudyData, selectedSectionType, selectedSectionId, pregunta, renderPreguntaPrincipal }) {
  if (!caseStudyData) {
    return (
      <div className="case-study-content">
        <p>No case study data available.</p>
      </div>
    );
  }

  const overview = caseStudyData.overview || '';
  const existingEnv = caseStudyData.existing_environment || { secciones: [] };
  const requirements = caseStudyData.requirements || { secciones: [] };

  // Si se selecciona la pregunta, mostrar solo la pregunta
  if (selectedSectionType === 'question') {
    return (
      <div className="case-study-content">
        <div className="case-study-content-header">
          <h3 className="case-study-content-title">Question</h3>
        </div>
        <div className="case-study-content-body">
          {pregunta && (
            <>
              <div className="pregunta-texto-container">
                <h4 className="pregunta-texto">
                  <TextoConImagenes
                    texto={pregunta.texto}
                    imagenes={pregunta.imagenes || []}
                    tablasContenido={pregunta.tablas_contenido || []}
                    basePath="/imagenes/"
                  />
                </h4>
              </div>
              {renderPreguntaPrincipal && renderPreguntaPrincipal()}
            </>
          )}
        </div>
      </div>
    );
  }

  let contenido = '';
  let titulo = '';

  if (selectedSectionType === 'overview') {
    titulo = 'Overview';
    contenido = overview;
  } else if (selectedSectionType === 'existing' && selectedSectionId) {
    const seccion = existingEnv.secciones?.find((s) => s.id === selectedSectionId);
    if (seccion) {
      titulo = seccion.titulo;
      contenido = seccion.contenido || '';
    }
  } else if (selectedSectionType === 'requirements' && selectedSectionId) {
    const seccion = requirements.secciones?.find((s) => s.id === selectedSectionId);
    if (seccion) {
      titulo = seccion.titulo;
      contenido = seccion.contenido || '';
    }
  }

  return (
    <div className="case-study-content">
      <div className="case-study-content-header">
        <h3 className="case-study-content-title">{titulo}</h3>
      </div>
      <div className="case-study-content-body">
        <TextoConImagenes
          texto={contenido}
          imagenes={[]}
          basePath="/imagenes/"
        />
      </div>
    </div>
  );
}

export default CaseStudyContent;
